'use client'

import GlobalModal from "./../../video-lab/global-modal";

export function AppGlobalModal({ children }: { children: React.ReactNode }) {
  return (
    <GlobalModal>
      {children}
    </GlobalModal>
  );
}
